export default __webpack_public_path__ + "images/a31e8cd60a5a7c1cfec50eee71f79a32.png";